const o = (t, e = 1) => {
  const n = Math.max(e, 1) || 1, r = (typeof t == "string" ? parseInt(t, 10) : t) || 60, i = r * n;
  return { imageHeight: r, wrapperWidth: i };
};
export {
  o as getFilePreviewSize
};
//# sourceMappingURL=InlineFilePreviewView.utils.mjs.map
